export const LOCALSTORAGE_INCLUDE_NEW_CONSTRUCTION_KEY = 'analysisSettings.includeNewConstruction';

/** Raw stored value, or `null` if missing/invalid (caller supplies URL / default). */
export function readIncludeNewConstructionLocalStorageValue(): boolean | null {
  if (typeof window === 'undefined') {
    return null;
  }
  const raw = localStorage.getItem(LOCALSTORAGE_INCLUDE_NEW_CONSTRUCTION_KEY);
  if (raw === 'true') return true;
  if (raw === 'false') return false;
  return null;
}
